import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Title, Wrapper, IconContainer } from "./style";

const Item = ({ title, path, icon: Icon }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [hovered, setHovered] = useState(false);

  const isActive = (checkPath) => window.location.pathname.includes(checkPath);

  const handleNavigate = (path) => {
    if (location.pathname === "/") {
      navigate(path, { replace: true });
    } else {
      navigate(path, { replace: true });
    }
  };

  return (
    <Wrapper>
      <Container
        onMouseOver={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        active={isActive(path)}
        hovered={hovered}
        onClick={() => handleNavigate(path)}
        title={title}
      >
        <Container.Left>
          <IconContainer active={isActive(path)} hovered={hovered}>
            <Icon size={22} />
          </IconContainer>
          <Title hovered={hovered} active={isActive(path)}>
            {title}
          </Title>
        </Container.Left>
        {isActive(path) && <span className="border" />}
      </Container>
    </Wrapper>
  );
};

export default Item;
